import React from "react";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import {
  defaultExpandedFaqID,
  recordingFAQs,
} from "./RecordingFaqModal.constants";
import { DetailsSection } from "./components/DetailsSection";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import { openPricingPage } from "utils/Utils";

export const RecordingFaqModal = ({ open, onClose, showLock }) => {
  const [expanded, setExpanded] = React.useState(defaultExpandedFaqID);
  return (
    <ExlyModal
      open={open}
      onClose={onClose}
      onClickCross={onClose}
      title={
        <div className="tw-text-black tw-text-[18px] tw-font-bold tw-leading-normal">
          FAQs
        </div>
      }
      customFooter={<></>}
      className="!tw-p-[24px] !tw-bg-[#eae7fa] tw-flex tw-flex-col tw-gap-[24px] max-md:tw-p-[16px]"
      modal_props={{ modalPaperClassName: "tw-min-w-[604px]" }}
    >
      {recordingFAQs
        .filter((section) => !showLock || section.alwaysShow)
        .map((section) => {
          return (
            <div key={section.id}>
              <span className="tw-text-[#493AB1] tw-font-[500]">
                {section.heading}
              </span>
              {section.questions.map((item) => (
                <div className="tw-mt-4" key={item.id}>
                  <DetailsSection
                    id={item.id}
                    title={item.title}
                    icon={item.icon}
                    expanded={expanded}
                    setExpanded={setExpanded}
                  >
                    <div className="tw-text-[#27252299] tw-text-sm">
                      {item.description}
                    </div>
                  </DetailsSection>
                </div>
              ))}
            </div>
          );
        })}
      {showLock && (
        <div className="tw-flex tw-border tw-border-solid tw-border-[1.5px] tw-border-[#F7AD1E] tw-rounded-[6px] tw-bg-[#FEEFD1] tw-justify-evenly tw-items-center tw-flex-col tw-px-16 tw-py-5 tw-gap-3">
          <LockIcon className="!tw-text-[#F7AD1E] !tw-text-3xl" />
          <div className="tw-font-[400] tw-text-center">
            Upgrade your plan to
            <span className="tw-font-[600]">
              &nbsp;record your Zoom meetings&nbsp;
            </span>
            &
            <span className="tw-font-[600]">
              &nbsp;automatically create recorded courses&nbsp;
            </span>
            for your customers!
          </div>
          <div
            className="tw-flex tw-bg-[#F7AB16] tw-w-full tw-justify-center tw-items-center tw-text-white tw-font-bold tw-rounded tw-cursor-pointer tw-py-2"
            onClick={openPricingPage}
          >
            <LockOpenIcon />
            <div>Upgrade to Premium</div>
          </div>
        </div>
      )}
    </ExlyModal>
  );
};
